import { version } from "../../package.json";
export const SDK_VERSION = version;

export const CUSTOM_FUNDER_ADDRESS_PREFIX = "custom:";
